import "./notice-bar.css";
import { NoticeBar } from './notice-bar';
export default NoticeBar;